export default __webpack_public_path__ + "static/homepage-app-a5159716d1bfb8cd64642126343c5638.png";